import GrilleZonesKilometriquesDetailController from './grille.zones.kilometriques.detail.controller';

export default {
    template: require('./grille.zones.kilometriques.detail.html'),
    controller: GrilleZonesKilometriquesDetailController
};
